// extracted by mini-css-extract-plugin
export var container = "_66-0";
export var infoButton = "_66-1";
export var label = "_66-3";
export var labelExpanded = "_66-4";
export var price = "_66-5";
export var priceExpanded = "_66-6";
export var title = "_66-2";